import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import classnames from 'classnames'
import styles from './_productItem.css'
import Svg from 'components/util/Svg'

const messages = {
  'day': <FormattedMessage id='premium.frequency.daily' defaultMessage='Daily' />,
  'week': <FormattedMessage id='premium.frequency.weekly' defaultMessage='Weekly' />,
  'month': <FormattedMessage id='premium.frequency.monthly' defaultMessage='Monthly' />,
  'year': <FormattedMessage id='premium.frequency.early' defaultMessage='Yearly' />,
}

const propTypes = {
  onClick: PropTypes.func,
  price: PropTypes.string,
  active: PropTypes.bool,
  className: PropTypes.string,
  frequency: PropTypes.oneOf(['month', 'year']),
}

export function ProductItem (props) {
  const { active, price, frequency, onClick } = props
  const className = classnames(styles.container, props.className, {
    [styles.active]: active,
  })

  return (
    <div onClick={onClick} className={className}>
      <div className={styles.price}>{price}</div>
      <div className={styles.frequency}>{messages[frequency]}</div>
      <Svg className={styles.icon} name='check' />
    </div>
  )
}

ProductItem.propTypes = propTypes

export default ProductItem



// WEBPACK FOOTER //
// ./src/components/premium/ProductItem.jsx